// ============================================================================
// OBT F2-A — Hedef seçici veri hook'u
// ============================================================================
// Aktörün alt zincirini organizasyon modülünden çeker
// (GET /organizasyon/chains/child/{me}); düğümler isim + role_slug taşır.
// Yalnız TARGETABLE_ROLES'e filtrelenir. Backend yayın anında YENİDEN doğrular;
// bu istemci filtresi salt UX'tir — yetki kapsamı dışı kişi UI'de listelenmez.
//
// Rol adı veya hiyerarşi ID'si İSTEMCİDE ÜRETİLMEZ; tümü backend'den gelir.
// ============================================================================

import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchChildChain } from './campaignApi';
import { OBT_TARGETABLE_ROLES } from './campaignEnums';
import { normalizeObtError } from '../obtErrors';

function isCanceled(error) {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
}

/**
 * @param {string} personnelId aktörün personel kimliği (auth kaynağından)
 * @param {{enabled?: boolean}} options
 */
export function useTargetTree(personnelId, { enabled = true } = {}) {
  const [state, setState] = useState({
    loading: enabled && Boolean(personnelId),
    error: null,
    candidates: [],
  });
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (!enabled || !personnelId) {
      setState({ loading: false, error: null, candidates: [] });
      return;
    }
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setState((prev) => ({ ...prev, loading: true, error: null }));

    try {
      const chain = await fetchChildChain(personnelId, {
        signal: controller.signal,
      });
      if (controller.signal.aborted) return;
      const candidates = chain
        .filter((node) => OBT_TARGETABLE_ROLES.includes(node.role_slug))
        .map((node) => ({
          personnelId: node.personnel_id,
          name: node.name,
          roleSlug: node.role_slug,
          parentId: node.parent_personnel_id || null,
          depth: typeof node.depth === 'number' ? node.depth : 0,
        }));
      setState({ loading: false, error: null, candidates });
    } catch (error) {
      if (isCanceled(error) || controller.signal.aborted) return;
      setState({
        loading: false,
        error: normalizeObtError(error),
        candidates: [],
      });
    }
  }, [personnelId, enabled]);

  useEffect(() => {
    load();
    return () => abortRef.current?.abort();
  }, [load]);

  return { ...state, reload: load };
}
